import backofficeService from '../../api/backoffice'

export default {
  /**
   * Get list of products
   * @param {*} params
   * @param {*} params.limit
   * @param {*} params.offset
   * @param {*} params.search
   * @param {*} params.local Add LocalData to products
   */
  getCustomerById(data) {
    return backofficeService.Api().post('stripe/customer/get', data)
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },

  createCustomer(data) {
    return backofficeService.Api().post('stripe/customer/create', data)
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },

  changeDefaultCard(data) {
    return backofficeService.Api().post('stripe/customer/changeDefaultCard', data)
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },

  chargeCustomer(data) {
    return backofficeService.Api().post('payCompass/customer/charge', data)
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },

  chargeCustomerForMultipleInvoice(data) {
    return backofficeService.Api().post('payCompass/customer/chargeMultipleInvoice', data)
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },

  creditAmount(data) {
    return backofficeService.Api().post('payCompass/customer/credit', data)
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },

  getTransaction(id) {
    return backofficeService.Api().get(`payCompass/charge/getById/${id}`)
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },

  getTransactionById(id) {
    return backofficeService.Api().get(`payCompass/transaction/getById/${id}`)
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },

  refundCharge(data) {
    return backofficeService.Api().post('payCompass/charge/refund', data)
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },

  voidTransaction(data) {
    return backofficeService.Api().post('payCompass/charge/void', data)
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },

  SubListByCustomer(data) {
    return backofficeService.Api().post('stripe/subscription/list', data)
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },
  getAllCard(id) {
    return backofficeService.Api().get(`payCompass/card/getAll/${id}`)
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },
  deleteCard(id) {
    return backofficeService.Api().post(`payCompass/card/delete/${id}`)
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },
  addCard(data) {
    return backofficeService.Api().post('payCompass/card/create', data)
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },

}